/*
 * @Author: 曹捷
 * @Date: 2019-08-15 15:07:21
 * @LastEditors: 曹捷
 * @LastEditTime: 2021-10-25 10:04:31
 * @Description: 用于模拟后台数据接口请求的，all 全部关闭 ，其他的分开选择是否打开引入子模块
 */
import Mock from 'mockjs'

const mockSwitch = {
    all: true,
}

if (process.env.NODE_ENV === 'development' && mockSwitch.all) {
    window.baseURL = ''
    require('./children/system.js')
    Mock.setup({
        timeout: 1000 // 拦截ajax请求时间超过的 进入mock数据模拟
    })
    console.warn('mock mounted!')
}
